module.exports = __webpack_public_path__ + "media/images/front/banner_clinical-conference_top_2-df9d4aee503ac0722fbd18c63c9bd93a.jpg";